export default {
  text: '{{threshold}} i månedligt salg: {{amount}}',
  label: '{{threshold}} i månedligt salg:',
  no_discount: 'ingen rabat',
  discount_badge: '-{{percentage}}%',
};
